export default __webpack_public_path__ + "static/media/eventSlide2.d8596eca.png";